export class PaymentProviderModel {
  id: number;
  hotel_id: number;
  provider: string;
  name: string;
  description: string;
  api_key: string;
  secret_key: string;
  public_key: string;
  server: string;
  user_name: string;
  password: string;
  use_3_d: boolean;
  supported_currencies: string[];
  pin: string;
  merchant_id: number;
  sub_merchant_id: number;
  test_secret_key: string;
  test_key: string;
  test_public_key: string;
  payment_profile_support: boolean;
  terminal_id: string;
  merchant_pass: string;
  terminal_user_id: string;
  terminal_prov_user_id: string;
  provision_password: string;
  security_type: string;
  transaction_type: string;
  use_sandbox: boolean;
  terminal_token: string;

  constructor() {
    this.id = 0;
    this.hotel_id = 0;
    this.provider = "";
    this.name = "";
    this.description = "";
    this.api_key = "";
    this.secret_key = "";
    this.public_key = "";
    this.server = "";
    this.user_name = "";
    this.password = "";
    this.use_3_d = false;
    this.supported_currencies = [];
    this.pin = "";
    this.merchant_id = 0;
    this.sub_merchant_id = 0;
    this.test_secret_key = "";
    this.test_key = "";
    this.test_public_key = "";
    this.payment_profile_support = false;
    this.terminal_id = "";
    this.merchant_pass = "";
    this.terminal_user_id = "";
    this.terminal_prov_user_id = "";
    this.security_type = "";
    this.transaction_type = "";
    this.use_sandbox = false;
    this.terminal_token = "";
    this.provision_password = "";
  }
}
